import React from 'react';
import { X } from 'lucide-react';

const ProjectModal = ({ project, isOpen, onClose }) => {
  if (!isOpen) return null;

  // Extract folder ID from Google Drive link
  const getFolderId = (link) => {
    const match = link.match(/folders\/([a-zA-Z0-9-_]+)/);
    return match ? match[1] : null;
  };

  const folderId = getFolderId(project.driveLink);
  const embedUrl = folderId 
    ? `https://drive.google.com/embeddedfolderview?id=${folderId}#grid`
    : null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-[#1a1a1c] rounded-lg max-w-6xl w-full max-h-[90vh] overflow-hidden relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <div>
            <h2 
              className="text-2xl font-serif text-white"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {project.name}
            </h2>
            <p className="text-[#FF8C42] text-sm mt-1">{project.type} • {project.location}</p>
          </div>
          <button
            onClick={onClose}
            className="text-white/60 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          {embedUrl ? (
            <iframe
              src={embedUrl}
              className="w-full h-[600px] border-0 rounded"
              title={`${project.name} Gallery`}
            />
          ) : (
            <div className="text-center py-20">
              <p className="text-white/70 mb-4">Project photos available on request</p>
              <div className="flex gap-4 justify-center">
                <a
                  href={`https://wa.me/919902199065?text=Hi, I'd like to see photos of ${project.name}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-sm transition-all"
                >
                  WhatsApp
                </a>
                <a
                  href="mailto:classic.decor24@gmail.com?subject=Photos Request"
                  className="px-6 py-3 bg-[#FF8C42] hover:bg-[#ff9d5c] text-white rounded-sm transition-all"
                >
                  Email
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
